import * as React from 'react'
import { IHolidayItem, IWorkingHoursItem } from '../../../types/index'
import ServiceViewHolidays from './ServiceViewHolidays'
import ServiceViewWorkingHours from './ServiceViewWorkingHours'

interface IServiceViewServiceDaysProps {
  serviceId: string
  orgId: string
  holidaysList: { [key: string]: IHolidayItem }
  workingHoursList: { [key: number]: IWorkingHoursItem }
  isAllDaysActive: boolean
  onComponentMount: (serviceId: string, orgId: string) => void
}

class ServiceViewServiceDays extends React.Component<IServiceViewServiceDaysProps> {
  constructor(props: IServiceViewServiceDaysProps) {
    super(props)
  }

  public componentDidMount() {
    const { serviceId, orgId, onComponentMount } = this.props
    onComponentMount(serviceId, orgId)
  }

  public render() {
    const { isAllDaysActive, workingHoursList, holidaysList } = this.props

    return (
      <div className='ml3'>
        <div className='h4 mt3 bold font-dark-grey'>Service Days & Hours</div>
        <AllDaysActive isAllDaysActive={isAllDaysActive} />
        <ServiceViewWorkingHours workingHoursList={workingHoursList} />

        <div className='h4 mt3 bold font-dark-grey'>Holidays & Closures</div>
        <ServiceViewHolidays holidaysList={holidaysList} />
      </div>
    )
  }
}

const AllDaysActive = ({ isAllDaysActive }: { isAllDaysActive: boolean }) => (
  <div className='flex flex-row justify-start items-center mt2'>
    <span className='h5 font-dark-grey mr2'>Availability 24/7</span>
    {isAllDaysActive ? (
      <span className='h5 font-green bold'>ON</span>
    ) : (
      <span className='h5 font-dark-grey bold'>OFF</span>
    )}
  </div>
)

export default ServiceViewServiceDays



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewServiceDays.tsx